import { ContentStateInterface, ContentStateProperty } from '../../../@types/types'
import {
  AbstractScreenValidationResult,
  ScreenValidationResult,
  ValidationResult,
  ValidationSchema,
} from '../../../@types/validation-types'
import { validate } from '../validationService'
import { AddressFeatureState } from '../../../@types/state-types'

export const runValidation = (
  insertionData: ContentStateInterface,
  addressFeature: AddressFeatureState,
  validationSchemaFactory: ValidationSchema
) => {
  const validationMessages: ValidationResult = validate(insertionData, addressFeature, validationSchemaFactory)

  validationMessages.address.fields = {
    ...validationMessages.address.fields!,
    manualRegion: !addressFeature.hasValidGeoCoordinates ? validationMessages.address.fields?.manualRegion : [],
    manualCity: !addressFeature.hasValidGeoCoordinates ? validationMessages.address.fields?.manualCity : [],
    manualQuarter: !addressFeature.hasValidGeoCoordinates ? validationMessages.address.fields?.manualQuarter : [],
  }
  return validationMessages
}

export const hasErrors = (
  validationMessages: ScreenValidationResult<AbstractScreenValidationResult>,
  fieldsToConsider?: ContentStateProperty[]
) =>
  validationMessages?.fields &&
  Object.entries(validationMessages.fields)
    .filter(([property]) => !fieldsToConsider || fieldsToConsider.includes(property as keyof ContentStateInterface))
    .some(([_property, messages]) => messages && messages.length)
